import Ranking from "../../components/Ranking";
function RankingPage() {
  return <Ranking />;
}

export default RankingPage;
